export default "__VITE_ASSET__cd944213__"